import { render, staticRenderFns } from "./AudiometryHistoryTable.vue?vue&type=template&id=4bd1ae93&"
import script from "./AudiometryHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AudiometryHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports